import * as React from "react";

function SvgBackArrow(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={13} height={19.512} {...props}>
        <path
          d="M11.888 19.512a1.124 1.124 0 01-.7-.244L.414 10.599A1.112 1.112 0 010 9.732a1.107 1.107 0 01.414-.865L11.145.244a1.111 1.111 0 011.561.17 1.111 1.111 0 01-.17 1.561L2.884 9.732l9.7 7.8a1.111 1.111 0 01.17 1.561 1.114 1.114 0 01-.866.419z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgBackArrow;
